/**
 * @generated SignedSource<<2bbcb0f04dad2e26feda0d6710aa915d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LinkProductComponentQuery$variables = {
  ean: string;
};
export type LinkProductComponentQuery$data = {
  readonly currentStore: {
    readonly productByEAN: {
      readonly id: string;
      readonly imageUrl: string | null;
      readonly name: string | null;
      readonly partNumber: string | null;
    } | null;
  };
};
export type LinkProductComponentQuery = {
  response: LinkProductComponentQuery$data;
  variables: LinkProductComponentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ean"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "ean",
      "variableName": "ean"
    }
  ],
  "concreteType": "StoreProduct",
  "kind": "LinkedField",
  "name": "productByEAN",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "partNumber",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LinkProductComponentQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Store",
          "kind": "LinkedField",
          "name": "currentStore",
          "plural": false,
          "selections": [
            (v2/*: any*/)
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LinkProductComponentQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "currentStore",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1cd056731280bd27c76b56b359b74e7e",
    "id": null,
    "metadata": {},
    "name": "LinkProductComponentQuery",
    "operationKind": "query",
    "text": "query LinkProductComponentQuery(\n  $ean: String!\n) {\n  currentStore {\n    productByEAN(ean: $ean) {\n      id\n      imageUrl\n      name\n      partNumber\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "585c13671987651ec34cdb8c623ed844";

export default node;
